import React from 'react'
import { Input, Button, Form } from 'antd'
import { UserOutlined, LockOutlined, WarningOutlined, LoadingOutlined } from '@ant-design/icons';
import axios from 'axios'

import {
    BACKEND_SERVICE_BASE_URL
} from '../../constants'
import {
    storeToken,
    unhideData,
    populateLocalStorage,
    hideData
} from '../../functions'

import './Login.scss'

class Login extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            has_error: false,
            error_message: '',
            login_loading: false
        }

        this.formRef = React.createRef()
    }

    componentDidMount() {
        this.formRef.current.resetFields()
    }

    onLogin = (data) => {
        this.setState({
            login_loading: true
        })
        this.onPostCredentials({data: hideData(data)})
    }

    clearError = () => {
        this.formRef.current.resetFields()
        this.setState({
            has_error: false,
            error_message: ''
        })
    }

    onPostCredentials = (data) => {
        axios.post(`${BACKEND_SERVICE_BASE_URL}/api/authenticate`, data)
            .then(res => {
                const { data } = res
                const { success, value, message } = data
                console.log("res", res)

                this.setState({
                    login_loading: false
                })

                if(success) {
                    this.setState({
                        has_error: false,
                        error_message: ''
                    })
                    
                    populateLocalStorage(unhideData(data.data))
                    storeToken(data.token)
                    this.props.loginVisibilitySetter(false)
                    window.location.reload(true)
                } else {
                    const messageSetter = (err_value) => {
                        if(err_value === 'USER_NOT_FOUND') {
                            return 'Invalid credentials'
                        } else if (err_value === 'INCORRECT_PASSWORD') {
                            return 'Incorrect username or password'
                        } else if (err_value === 'ACCOUNT_NOT_ACTIVATED') {
                            return message
                        } else {
                            return 'Error'
                        }
                    }

                    this.setState({
                        has_error: true,
                        error_message: messageSetter(value)
                    })
                }
            })
            .catch(err => {
                console.log("ERR: ", err)
            })
    }   

    render() {
        return (
            <div className="login__container">
                <div className="login__heading">
                    Sign In
                </div>
                <Form
                    hideRequiredMark={true}
                    layout='vertical'
                    onFinish={e => { if(!this.state.login_loading){ this.onLogin(e) }}}
                    onFinishFailed={e => console.log("FAILED: ", e)}
                    initialValues={{ remember: false }}
                    ref={this.formRef}
                    autoComplete="off"
                    autoFill='off'
                >
                    <Form.Item
                        label="Username"
                        name="username"
                        rules={[{ required: true, message: 'Please input your Username!' }]}
                        className="login__form-item"
                    >
                        <Input 
                            autoComplete="new-password"
                            prefix={<UserOutlined className="site-form-item-icon" />} 
                            placeholder="Username" 
                            onChange={e => {
                                this.setState({
                                    has_error: false,
                                    error_message: ''
                                })
                            }}
                        />
                    </Form.Item>
                    <Form.Item
                        label="Password"
                        name="password"
                        rules={[{ required: true, message: 'Please input your Password!' }]}
                        className="login__form-item"
                    >
                        <Input
                            autoComplete="new-password"
                            prefix={<LockOutlined className="site-form-item-icon" />}
                            type="password"
                            placeholder="Password"
                            onChange={e => {
                                this.setState({
                                    has_error: false,
                                    error_message: ''
                                })
                            }}
                        />
                    </Form.Item>
                    <Form.Item>
                      <Button 
                          type="primary" 
                          htmlType="submit" 
                          className="login__button--submit"
                      >
                        <LoadingOutlined 
                            style={{ display: this.state.login_loading? null : 'none' }}
                            className="login__loading-icon"
                        /> {this.state.login_loading? 'Logging In...' : 'Log In'}
                      </Button>
                    </Form.Item>
                </Form>
                {this.state.has_error? 
                    <React.Fragment>
                        <div className="login__error-div">
                            <WarningOutlined className="login__error-icon"/> {this.state.error_message}
                        </div>
                    </React.Fragment>
                : null}
            </div>
        )
    }
}

export default Login